export default function getResource(label, vars = []) {
    const resources = {
        freeShippingMessage: `You’re only ${vars[0]} away from Free Shipping.`
    };

    return resources[label];
}
